import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { FlexService } from 'src/app/core/services/http/flex/flex.service';
import { Flex } from 'src/app/core/services/http/flex/interfaces/flex';
import { DateManagerService } from 'src/app/core/services/date-manager/date-manager.service';
import { Paging } from 'src/app/core/services/http/general/classes/paging';
import { ExtendedDate } from 'src/app/core/services/date-manager/classes/extended-date';
import { EventType } from "src/app/constants/events-type";
import { EventManagerService } from "src/app/core/services/event-manager/event-manager.service";
import { DashboardService } from 'src/app/core/services/http/dashboard/dashboard.service';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-flex-drop-down',
  templateUrl: './flex-drop-down.component.html'
})
export class FlexDropDownComponent extends DestroyNotifierComponent implements OnInit {
  @Output() selectedFlexChange = new EventEmitter();
  @Output() flexsLoaded = new EventEmitter<Flex[]>();

  @Input() hideSelectAllFlexs: boolean | undefined;
  @Input() shouldShowAllFlexs: boolean | undefined;
  @Input() flexs: Flex[] = [];
  @Input() selectedCalendarDate: ExtendedDate | undefined;
  @Input() isFlexSelected: boolean | undefined;
  @Input() selectedFlexForAttendance: Flex | undefined;

  constructor(
    private flexService: FlexService,
    private translate: TranslateService,
    private dateManagerService: DateManagerService,
    private eventManager: EventManagerService,
    private dashboardService: DashboardService,
    private localStorageService: LocalStorageService
  ) {
    super();
  }

  ngOnChanges(): void {
      if(this.selectedFlexForAttendance == undefined){  
        this.loadFlexs();
        if(this.selectedCalendarDate){
          this.setRunAlgoButtonStatus();
        }
    }
  }

  ngOnInit(): void {
    if (!this.flexs.length) {
      this.loadFlexs();
      this.eventManager.subscribe(EventType.AutoAssignStatus, () => {
        this.setRunAlgoButtonStatus()
      });
    }
  }

  onSelectFlex(flex: Flex): void {
    this.selectedFlexChange.emit(flex);

    if(this.selectedCalendarDate){
      this.localStorageService.setItem('flexPeriod', JSON.stringify(flex));
    }
  }

  loadFlexs(date?: ExtendedDate): void {
    let filter = { status: 1 };

    if (date) {
      this.selectedCalendarDate = date;
    }

    if (this.selectedCalendarDate) {
      filter = { ...filter, ...{ date: this.dateManagerService.dateToString(this.selectedCalendarDate) } };
    }

    this.flexService
      .getAll(new Paging().getAllRecords(), filter)
      .pipe(takeUntil(this.destroyNotify))
      .subscribe(flexs => {
        this.flexs = this.addAllFlexsByShouldShowAllFlexs(flexs);
        this.flexsLoaded.emit(this.flexs);
        this.setDefaultFlex();
      });
  }

  setDefaultFlex(): void {
    if (this.flexs?.length) {
      if((this.selectedCalendarDate && !this.isFlexSelected) || !this.selectedCalendarDate){  
        // Don't auto-select when showing "All Flex Periods"
        if (this.shouldShowAllFlexs || this.hideSelectAllFlexs) {
          return;
        }
        let flexPeriod:any;
        if(this.selectedFlexForAttendance){
          flexPeriod = this.selectedFlexForAttendance
        }else{
          flexPeriod = JSON.parse(this.localStorageService.getItem('flexPeriod') || 'null');
        }

        const flexFound = this.flexs.find(flex => flex.uuid === flexPeriod?.uuid);

        if (flexFound) {
          this.selectedFlexChange.emit(flexFound);
        }else{
          this.selectedFlexChange.emit(this.flexs[0]);
        }
      }
    }else {
      const noFlexs: any = [
        {
          name: this.translate.instant('NO_FLEX_AVAILABLE'),
          isFlexDisabled: true  
        }
      ]

      this.flexs = noFlexs;
      this.selectedFlexChange.emit(this.flexs[0]);
    }
  }

  addAllFlexsByShouldShowAllFlexs(flexs: Flex[]): Flex[] {
    if (this.shouldShowAllFlexs) {
      const clonedFlexs = [...flexs];
      // @ts-ignore
      clonedFlexs.unshift({ name: 'All Flex Periods', flexTimeStr: '' });

      return clonedFlexs;
    } else {
      return flexs;
    }
  }

  setRunAlgoButtonStatus(){
     
    this.flexs?.forEach((flex)=>{
      flex.isAssignMentIsInprocess = false;
    })

    const selectedCalendarDate = this.dashboardService.formatDateToString(this.selectedCalendarDate as ExtendedDate);
    
    const uuidsForSelectedDate = new Set(
      this.dashboardService.listOfInProcessAlgorithmFlex
          .filter((item:any) => selectedCalendarDate === this.dashboardService.formatDateToString(item.date))
          .map((item:any) => item.uuid)
    );

    if (this.flexs?.length) {
      this.flexs.forEach(item => {
          if (uuidsForSelectedDate.has(item.uuid)) {
              item.isAssignMentIsInprocess = true;
          }
      });
    }
  }
}
